module.exports = __webpack_public_path__ + "27063f83e227c644e254a6473d9aece1.png";


//////////////////
// WEBPACK FOOTER
// ./components/home/brokerage/diploma.png
// module id = 704
// module chunks = 0